<template>
	<main class="main">
		<!-- <p v-if="isMobile">Is Mobile</p>
		<p v-if="isDesktop">Is Desktop</p> -->
		<div v-if="isMobile && (messageSync == 'end' || messageSync == 'error')" class="buttons">
			<router-link class="btn dashboard_button" :to="{ name: 'checksheetwizard', params: {}}">
				{{$t('checksheet.title')}}
			</router-link>
			<router-link class="btn dashboard_button" :to="{ name: 'interventionreportwizard', params: {}}">
				{{$t('interventionreport.title')}}
			</router-link>


			<router-link class="btn dashboard_button" :to="{ name: 'checksheetoffline', params: {}}">
				{{$t('checksheet.titleList')}}
			</router-link>
			<router-link class="btn dashboard_button" :to="{ name: 'interventionreportoffline', params: {}}">
				{{$t('interventionreport.titleList')}}
			</router-link>

			<router-link class="btn dashboard_button" :to="{ name: 'checksheetofflinesaved', params: {}}">
				{{$t('checksheet.titleListSaved')}}
			</router-link>
			<router-link class="btn dashboard_button" :to="{ name: 'interventionreportofflinesaved', params: {}}">
				{{$t('interventionreport.titleListSaved')}}
			</router-link>
		</div>
		<div v-if="isMobile && messageSync != 'end' && messageSync != 'error'" class="message_sync">
			Sincronizzazione automatica in corso... ({{messageSync}})
		</div>
	</main>
</template>
<script>
    export default {
        name: 'dashboard',
        data() {
            return {
                sync: this.sync,
                messageSync: '',
                messageSyncParams: ''
            }
        },
        components: {},
        mounted() {
            this.syncronizeData();
        },
        methods: {
            /**
             *
             */
            syncronizeData() {
                if (navigator.onLine) {
                    this.sync.syncronizeTable('customers', (updated, params) => {
                        this.api.customers.offline.emptyData();
                        this.messageSync = updated;
                        this.messageSyncParams = params;
                        // finita la sincronizzazione dei customer,
                        // applico la sincronizzazione dei rapporti di intervento
                        if (updated == 'end') {
                            this.sync.syncronizeTable('intervention_reports', (updated, params) => {
                                this.messageSync = updated;
                                this.messageSyncParams = params;

                                // finita la sincronizzazione dei rapporti di intervento,
                                // applico la sincronizzazione delle schede di controllo
                                if (updated == 'end' || updated == 'error') {
                                    this.sync.syncronizeTable('check_sheets', (updated, params) => {
                                        this.messageSync = updated;
                                        this.messageSyncParams = params;
                                        if (updated == 'end') {
                                            // fine sincronizzazione
                                            // this.toast.success(this.$t(`common.sync.complete`));
                                        }
                                    });
                                }
                            });
                        }
                    });
                } else {
                    this.messageSync = "end";
                    this.messageSyncParams = "";
				}
            }
        }
    }
</script>
<style lang="scss">
	@import './src/scss/variables';

	.buttons {
		display: flex;
		flex-wrap: wrap;

		.btn {
			width: calc(100% - calc(var(--gutter) * 2));
			line-height: 1.6em;
			text-align: center;
			margin: var(--gutter);
			padding: 50px;
		}

		@media (min-width: 600px) {
			.btn {
				width: calc(50% - calc(var(--gutter) * 2));
			}
		}
	}

	.message_sync {
		padding: 20px;
	}
</style>
